import script from "./AdminTopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTopBar.vue?vue&type=script&setup=true&lang=js"

import "./AdminTopBar.vue?vue&type=style&index=0&id=6332f1a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6332f1a4"]])

export default __exports__